import styled from "styled-components";

export const H1Component = styled.h1`
    font-weight: 700;
    font-size: 18px;
    color: var(--text-color);
    display: flex;
    margin: 0;
    padding: 0;
`